import React, { useEffect, useMemo, useState } from "react";
import Hero from "../components/Hero";
import DealStrip from "../components/DealStrip";
import HomeCollectionStrip from "../components/HomeCollectionStrip";
import HomeCollectionRail from "../components/HomeCollectionRail";
import NewsletterForm from "../components/NewsletterForm";
import SpinWheel from "../components/SpinWheel";
import TavenSignupPopup from "../components/TavenSignupPopup";
import UpcomingLive from "../components/UpcomingLive";
import DailyEnergy from "../components/DailyEnergy";
import { TrustSection, SellerHubBanner, AffiliateBoutiqueBanner, KnowledgeHubBanner } from "../components/HomeSections";
import { MarketRail } from "../components/market/MarketRail";
import HomeBusiness from "../components/HomeBusiness";
import { cjFeed } from "../lib/cj";

// Product-first Home. Rails powered by the hybrid catalog (published CJ + Shopify) via /api/cj/*.
const RAILS = [
  { key: "flash-deals", label: "Flash Deals", accent: true },
  { key: "best-sellers", label: "Best Sellers" },
  { key: "trending", label: "Trending Now" },
  { key: "new-arrivals", label: "New Arrivals" },
  { key: "recommended", label: "Recommended For You" },
  { key: "recently-added", label: "More Products" },
];

const pkey = (p) => p.taven_product_id || p.shopify_product_id || p.id || p.sku || p.handle;

export const Home = () => {
  const [raw, setRaw] = useState({});

  useEffect(() => {
    let active = true;
    RAILS.forEach(({ key }) => {
      cjFeed(key, 48)
        .then((d) => { if (active) setRaw((prev) => ({ ...prev, [key]: d.products || [] })); })
        .catch(() => {});
    });
    return () => { active = false; };
  }, []);

  // Display-level dedup across rails (flash-deals first). Each rail shows up to 12 distinct products.
  const deduped = useMemo(() => {
    const seen = new Set();
    const out = {};
    RAILS.forEach(({ key }) => {
      const items = [];
      for (const p of (raw[key] || [])) {
        const k = pkey(p);
        if (!k || seen.has(k)) continue;
        seen.add(k); items.push(p);
        if (items.length >= 12) break;
      }
      out[key] = items;
    });
    return out;
  }, [raw]);

  const rail = ({ key, label, accent }) => (
    <MarketRail key={key} title={label} products={deduped[key] || []} accent={accent}
      viewAllTo={key === "flash-deals" ? undefined : "/shop"} />
  );

  return (
    <div data-testid="home-page">
      <Hero />
      <DealStrip />
      <HomeCollectionStrip />

      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-8" data-testid="home-hybrid-rails">
        {RAILS.slice(0, 3).map(rail)}
        <HomeCollectionRail handle="perfume-fragrance" title="Perfume & Fragrance" />
      </div>
      <SellerHubBanner />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <HomeCollectionRail handle="womens-tops" title="Women's Fashion" />
        <HomeCollectionRail handle="mens-outerwear" title="Men's Fashion" />
        <HomeCollectionRail handle="womens-shoes" title="Shoes" />
        <HomeCollectionRail handle="skin-care" title="Beauty & Personal Care" />
        <HomeCollectionRail handle="kitchen-dining-bar" title="Home & Kitchen" />
        <HomeCollectionRail handle="smart-electronics" title="Electronics" />
        <HomeCollectionRail handle="fashion-jewelry" title="Jewelry & Watches" />
        {RAILS.slice(3).map(rail)}
      </div>

      <HomeBusiness />

      <AffiliateBoutiqueBanner />
      <KnowledgeHubBanner />
      <UpcomingLive />
      <DailyEnergy />
      <TrustSection />
      <NewsletterForm />

      <SpinWheel />
      <TavenSignupPopup />
    </div>
  );
};

export default Home;
